import { Injectable } from '@angular/core';
import { ObjectRestService } from '@base/modules/rest/object/object-rest.service';
import { HttpClient } from '@angular/common/http';
import { ObjectNameEnum } from '@base/modules/rest/master-data-history/model/enums/object-name.enum';
import { BbsObjectRestService } from '@base/modules/rest/bbs-object/bbs-object-rest.service';
import { Observable } from 'rxjs';
import { ObjectFindRequestModel } from '@base/modules/rest/object/model/object-find-request.model';
import { PaginationResponseModel } from '@base/model/common/pagination-response.model';
import { AppConfiguration } from '../../../../app-configuration';

@Injectable({
  providedIn: 'root',
})
export class BbsObjectRestAdapterService extends ObjectRestService {

  constructor(httpClient: HttpClient,
              appConfiguration: AppConfiguration,
              private bbsObjectRestService: BbsObjectRestService) {
    super(httpClient, appConfiguration, ObjectNameEnum.BbsObject, null);
  }

  find(data: ObjectFindRequestModel): Observable<PaginationResponseModel<any>> {
    return this.bbsObjectRestService.findAll({
      pagination: {
        ...data.page,
        filter: data.filter,
      },
      includeNonMcm: data.params?.includeNonMcm == null ? true : data.params.includeNonMcm,
      queryOnlyBbsObject: data.params?.queryOnlyBbsObject ?? false,
    });
  }

  findOne(payload: { id: number }): Observable<any> {
    return this.bbsObjectRestService.findOne(payload);
  }

  findOneSimple(payload: { id: number }): Observable<any> {
    return this.bbsObjectRestService.findOne(payload);
  }

  create(payload: { item: any }): Observable<any> {
    return this.bbsObjectRestService.create({bbsObject: payload.item});
  }

  update(payload: { id: number; item: any }): Observable<any> {
    return this.bbsObjectRestService.update({id: payload.id, bbsObject: payload.item});
  }

  delete(payload: { id: number }): Observable<void> {
    throw new Error('Method not implemented');
  }
}
